import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Initialize Bitcoin API and data systems
import { createAPIManager } from './core/data/APIManager'
import { eventBus } from './core/state/EventBus'
import { logger } from './core/utils/Logger'

async function initializeApp() {
  try {
    // Create and initialize API manager with real Bitcoin data and shared eventBus
    const apiManager = createAPIManager({
      mempool: {
        baseUrl: 'https://mempool.space',
        wsUrl: 'wss://mempool.space/api/v1/ws',
        rateLimit: 100,
      },
      blockchain: {
        wsUrl: 'wss://ws.blockchain.info/inv',
      },
      testMode: false, // Use real APIs
      mockDataEnabled: false,
    }, eventBus);

    await apiManager.initialize();
    logger.info('Bitcoin API Manager initialized with real data', 'App');

    // Start real-time data updates
    // await apiManager.fetchInitialData(); // TODO: Make this method public or find alternative
    
  } catch (error) {
    logger.error('Failed to initialize Bitcoin APIs, falling back to test mode', 'App', error as Error);
    
    // Fallback to test mode if real APIs fail
    const fallbackApiManager = createAPIManager({
      mempool: {
        baseUrl: 'https://mempool.space',
        wsUrl: 'wss://mempool.space/api/v1/ws',
        rateLimit: 100,
      },
      blockchain: {
        wsUrl: 'wss://ws.blockchain.info/inv',
      },
      testMode: true,
      mockDataEnabled: true,
    }, eventBus);
    await fallbackApiManager.initialize();
  }
}

// Initialize app with real data
initializeApp().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
});